import React from 'react';
import { Hero } from '../components/Hero';
import { PainNarrative } from '../components/PainNarrative';
import { SolutionDetails } from '../components/SolutionDetails';
import { ProductBreakdown } from '../components/ProductBreakdown';
import { PricingSection } from '../components/PricingSection';
import { StickyBar } from '../components/StickyBar';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-stone-900 selection:bg-rose-200 selection:text-rose-900" data-id="element-233">
      <Hero data-id="element-234" />
      <PainNarrative data-id="element-235" />
      <SolutionDetails data-id="element-236" />
      <ProductBreakdown data-id="element-237" />
      <PricingSection data-id="element-238" />
      <StickyBar data-id="element-239" />
      <Footer data-id="element-240" />
    </div>;
}